import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PhotoThumbnails = ({ photos, maxDisplay = 3, size = 'sm' }) => {
  if (!photos || photos?.length === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        No photos
      </div>
    );
  }

  const displayPhotos = photos?.slice(0, maxDisplay);
  const remainingCount = photos?.length - maxDisplay;
  
  const thumbnailSize = size === 'lg' ? 'w-16 h-16' : size === 'md' ? 'w-12 h-12' : 'w-8 h-8';

  return (
    <div className="flex items-center gap-1">
      {displayPhotos?.map((photo, index) => (
        <div
          key={photo?.id || index}
          className={`${thumbnailSize} rounded border border-border overflow-hidden bg-muted/30 flex-shrink-0`}
          title={photo?.caption || `Photo ${index + 1}`}
        >
          <Image
            src={photo?.thumbnail || photo?.url}
            alt={photo?.caption || `Installation photo ${index + 1}`}
            className="w-full h-full object-cover"
            fallback={
              <div className="w-full h-full flex items-center justify-center">
                <Icon name="Image" size={size === 'lg' ? 16 : size === 'md' ? 12 : 8} className="text-muted-foreground" />
              </div>
            }
          />
        </div>
      ))}
      {remainingCount > 0 && (
        <div className={`${thumbnailSize} rounded border border-border bg-muted/50 flex items-center justify-center flex-shrink-0`}>
          <span className="text-xs font-medium text-muted-foreground">
            +{remainingCount}
          </span>
        </div>
      )}
    </div>
  );
};

export default PhotoThumbnails;